<template>
  <div class="user login">
    <div class="cover">
      <div class="image">
        <c-account-image :has-img = "account.has_img" :account-id = "account.id" :account-name = "account.last_name + account.first_name" ></c-account-image>
      </div>
    </div>
    <div class="status">
      <div class="name">{{account.nickname}}さん</div>
      <div class="action">
        <router-link to = "/admin" v-if="loginFlg && account.admin_flg">管理メニュー</router-link>
        <router-link to="/settings">設定</router-link>
        <c-logout-anchor :icon="false"></c-logout-anchor>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue"
import { useStore } from 'vuex'
import 'vue-toast-notification/dist/theme-sugar.css';

// store取得
const $store = useStore();

// --- computed ---
const loginFlg = computed(() => $store.state.core.loginFlg);
const account = computed(() => $store.state.core.account);
</script>